import BankLogo from 'components/BankLogo'
import { Bank } from 'data/Payments/BankTransfer/types'
import React, { ReactNode } from 'react'

import { BigOptionBody, OptionContent, OptionTitle } from './styles'

type LogoProps = { bank: Bank }
const Logo = ({ bank }: LogoProps) => {
  if (!bank.details) return null
  const imageLink = (bank.details.media ?? [])[0]?.source
  if (imageLink) return <img src={imageLink} />
  return <BankLogo name={bank.details.bankName} />
}

const getDescription = (bank: Bank) => {
  if (!bank.details) return ''

  const {
    details: { accountName, accountNumber, bankAccountType, bic, iban, sortCode }
  } = bank

  if (accountNumber && bankAccountType) {
    return `${bankAccountType.toLowerCase()} ${accountNumber}`
  }

  if (accountName && iban && bic) {
    return `${accountName} ${iban} ${bic}`
  }

  if (accountName && sortCode) {
    return `${accountName} ${sortCode}`
  }

  return accountName
}

type Props = {
  bank: Bank
  children?: ReactNode
}
const BankOption = ({ bank, children }: Props) => (
  <>
    <Logo bank={bank} />
    <OptionContent>
      <OptionTitle>{bank.details?.bankName ?? 'Bank'}</OptionTitle>
      <BigOptionBody>{getDescription(bank)}</BigOptionBody>
      {children}
    </OptionContent>
  </>
)

export default BankOption
